import { render } from "./AppDropdownAllergens.vue?vue&type=template&id=0c50acd6&scoped=true"
import script from "./AppDropdownAllergens.vue?vue&type=script&lang=js"
export * from "./AppDropdownAllergens.vue?vue&type=script&lang=js"

import "./AppDropdownAllergens.vue?vue&type=style&index=0&id=0c50acd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c50acd6"]])

export default __exports__